import { render } from "./DashboardSolum.vue?vue&type=template&id=41ee4250&scoped=true"
import script from "./DashboardSolum.vue?vue&type=script&lang=js"
export * from "./DashboardSolum.vue?vue&type=script&lang=js"

import "./DashboardSolum.vue?vue&type=style&index=0&id=41ee4250&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ee4250"]])

export default __exports__